'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Title3", {
    enumerable: true,
    get: function() {
        return Title3;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useTitle3Stylesstyles = require("./useTitle3Styles.styles");
const Title3 = (0, _createPreset.createPreset)({
    useStyles: _useTitle3Stylesstyles.useTitle3Styles,
    className: _useTitle3Stylesstyles.title3ClassNames.root,
    displayName: 'Title3'
});
